import styled from 'styled-components';

import Typography from '@klv/atoms/typography';
import type { TCountdownBackground } from '@klv/organisms/countdown/types';

export const StyledCountdownTimer = styled.div<{ color: TCountdownBackground; }>`
  color: inherit;
  display:flex;
  align-items: flex-start;
  justify-content: center;
  gap: 1.6rem;
  ${({ theme, color }) => `
    color: ${theme.countdown[color].timer};
    ${theme.screenSize.s768.mediaQuery} {
      gap: 3.2rem;
    }
  `}
`;

export const CountdownNumberSlash = styled(Typography)`
  color: inherit;
`;

export const CountdownNumberContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  :after {
    display: block;
  }
`;

export const CountdownNumber = styled(Typography)`
  width: 2ch;
  overflow: visible;
`;

export const CountdownNumberLabel = styled(Typography)``;

export const Background = styled.div<{ $backgroundColor: TCountdownBackground; }>`
  background: ${({ $backgroundColor, theme }) => theme.colors[$backgroundColor]};
  width: 100%;
  padding: 1rem;
`;
